import type { ShareData } from "../lib/shareCard";

interface Props {
  data: ShareData;
  streak: number;
  genre?: string | null;
}

// Nigunim-branded share card is designed by the designer; this placeholder
// keeps existing call sites compiling until the final artwork lands.
export default function VinylShareCard(_: Props) {
  return (
    <div
      className="rounded-2xl p-6 text-center font-serif"
      style={{
        background: "var(--navy-800)",
        color: "var(--gold-400)",
        border: "1px solid var(--gold-500)",
      }}
    >
      כרטיס שיתוף יעוצב בהמשך
    </div>
  );
}
